const getVideoData = ({ target }) => {
    const parent = target.closest('.videoCube');
    return parent['video_data'];
};

export default getVideoData;
